import { Component, Injector, Input, OnInit } from '@angular/core';
import { Subscription } from '@node_modules/rxjs';
import { finalize } from '@node_modules/rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { AbpValidationError } from '@shared/components/validation/abp-validation.api';
import { StringUtils } from '@shared/helpers/StringUtils';
import { CreatePacienteDto, EnumDto, EnumServiceProxy, PacienteServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'dados-form-cadastro-paciente',
  templateUrl: './dados-form-cadastro-paciente.component.html',
  styleUrls: ['./dados-form-cadastro-paciente.component.scss']
})
export class DadosFormCadastroPacienteComponent extends AppComponentBase implements OnInit {

  @Input() paciente: CreatePacienteDto = new CreatePacienteDto();
  @Input() ehEstrangeiro: boolean = false;

  protected listaSexo: EnumDto[] = [];
  protected listaTipoSanguineo: EnumDto[] = [];
  protected listaCorEtnia: EnumDto[] = [];
  protected listaEstadoCivil: EnumDto[] = [];
  protected dataNascimento: string;
  protected showPassword: boolean = false;
  protected exibirNomeSocial: boolean = false;
  private subscriptions: Subscription[] = [];
  private passwordRegex = /(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?!.*\s)[0-9a-zA-Z!.@#$%^&*()]*$/;

  passwordValidationErrors: Partial<AbpValidationError>[] = [
    {
      name: "pattern",
      localizationKey:
        "PasswordsMustBeAtLeast8CharactersContainCharactersNumber",
    },
  ];

  newCnsValidationErrors: Partial<AbpValidationError>[] = [
    {
      name: "pattern",
      localizationKey: "CnsValidation",
    },
  ];

  constructor(
    injector: Injector,
    private readonly _pacienteService: PacienteServiceProxy,
    private readonly _enumService: EnumServiceProxy,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.obterListaSexo();
    this.obterListaCorEtnia();
    this.obterListaTipoSanguineo();
    this.obterListaEstadoCivil();
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  public updateData() {
    this.dataNascimento = this.paciente.dataNascimento.format("DD/MM/YYYY");
  }

  public isValided(): boolean {
    return this.showErros([
      { condition: StringUtils.isNullOrEmpty(this.paciente.nome), message: "Informe o nome!" },
      { condition: !this.paciente.isDependente && StringUtils.isNullOrEmpty(this.paciente.celular), message: "Informe o celular!" },
      { condition: !this.paciente.isDependente && StringUtils.isNullOrEmpty(this.paciente.senha), message: "Informe a senha!" },
      { condition: !this.paciente.isDependente && !this.senhaValida(this.paciente.senha), message: "A senha deve ter no mínimo 8 caracteres, conter letras e números e não pode ter espaços!" },
      { condition: StringUtils.isNullOrEmpty(this.paciente.sexo), message: "Informe o sexo!" }
    ]);
  }

  protected cnsOnBlur() {
    if (!this.paciente.cns) return;

    abp.ui.setBusy();
    this._pacienteService
      .cnsExistsOrInvalid(this.paciente.cns, null)
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      )
      .subscribe((resultado) => {
        if (resultado) {
          this.notify.error(this.l("CnsExistsOrInvalid"));
        }
      });
  }

  protected visualizarSenha() {
    this.showPassword = !this.showPassword;
  }

  private showErros(validations) {
    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }

  private obterListaSexo() {
    this.subscriptions.push(this._enumService.getByEnumName('SexoEnum').subscribe(x => {
      this.listaSexo = x.items;
    }));
  }

  private obterListaTipoSanguineo() {
    this.subscriptions.push(this._enumService.getByEnumName('TipoSanguineoEnum').subscribe(x => {
      this.listaTipoSanguineo = x.items;
    }));
  }

  private obterListaCorEtnia() {
    this.subscriptions.push(this._enumService.getByEnumName('CorEtniaEnum').subscribe(x => {
      this.listaCorEtnia = x.items;
    }));
  }

  private obterListaEstadoCivil() {
    this.subscriptions.push(this._enumService.getByEnumName('EstadoCivilEnum').subscribe(lista => {
      this.listaEstadoCivil = lista.items;
    }));
  }

  private senhaValida(senha: string): boolean {
    return this.passwordRegex.test(senha);
  }
}
